import { Box, Button, Typography, useTheme } from "@mui/material";
import { Minus, Plus } from "../../../icons";
import * as React from "react";

type InputQtyGridProps = {
  availableQty: number;
  disabled?: boolean;
  value: number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onValueChange?: (value: number) => void;
  dataVariantId?: any;
  dataWidth?: any;
  dataSize?: any;
  dataSelectedShank?: any;
};

export const InputQtyGrid: React.FC<InputQtyGridProps> = ({
  availableQty,
  disabled,
  value,
  onChange,
  onValueChange,
  dataVariantId,
  dataWidth,
  dataSize,
  dataSelectedShank,
}) => {
  const theme = useTheme();

  const clamp = (n: number) => {
    if (!Number.isFinite(n)) return 0;
    if (n < 0) return 0;
    if (n > availableQty) return availableQty;
    return n;
  };

  const notify = (next: number) => {
    const clamped = clamp(next);
    if (onValueChange) onValueChange(clamped);

    if (onChange) {
      const fakeEvent = {
        target: { value: String(clamped) },
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      onChange(fakeEvent);
    }
  };

  const onMinusQty = () => {
    if (disabled) return;
    notify((value ?? 0) - 1);
  };

  const onPlusQty = () => {
    if (disabled) return;
    notify((value ?? 0) + 1);
  };

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    const raw = e.target.value;
    if (raw === "") {
      notify(0);
      return;
    }
    const num = parseInt(raw, 10);
    if (Number.isNaN(num)) return;

    notify(num);
  };

  const buttonsDisabled = disabled || availableQty <= 0;

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
      <Box
        borderRadius={2}
        overflow="hidden"
        bgcolor={theme.palette.common.white}
        boxShadow={`0px 0px 0px 1px ${theme.palette.customColor?.dark}`}
        display="flex"
      >
        <Button
          size="small"
          onClick={onMinusQty}
          disabled={buttonsDisabled}
          sx={{ minWidth: 30, borderRadius: "0 !important", bgcolor: theme.palette.common.white }}
        >
          <Minus sx={{ maxWidth: 10, maxHeight: 10 }} />
        </Button>

        <input
          type="text"
          value={String(value ?? 0)}
          onChange={onInputChange}
          disabled={disabled}
          data-variant-id={dataVariantId}
          data-width={dataWidth}
          data-size={dataSize}
          data-shank={dataSelectedShank}
          style={{
            maxWidth: 40,
            padding: 8,
            border: "none",
            background: theme.palette.brand?.main,
            outline: "none",
            textAlign: "center",
          }}
        />

        <Button
          size="small"
          onClick={onPlusQty}
          disabled={buttonsDisabled || (value ?? 0) >= availableQty}
          sx={{ minWidth: 30, borderRadius: "0 !important", bgcolor: theme.palette.common.white }}
        >
          <Plus sx={{ maxWidth: 10, maxHeight: 10 }} />
        </Button>
      </Box>

      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          right: 5,
          bottom: 5,
          userSelect: "none",
          opacity: 0.7,
          color:
            availableQty > 0
              ? theme.palette.success.main
              : theme.palette.warning.main,
        }}
      >

        {isNaN(availableQty) ? `N/A`: `Avail: (${availableQty})`}

        
      </Typography>
    </Box>
  );
};
